export default {
  HI_FOLDING_GROUP: "HI-FOLDING-GROUP",
  HI_FORM_DATA: "HI-FORM-DATA",
};
